import React, { useState, useEffect, useContext, useRef, Suspense, useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  fmt,
  isEmptyObject,
  getLocalStorageObject,
  setLocalStorageObject,
  calculatePositionRealisedPnl,
  calculatePositionUnrealisedPnl,
  exitOrder,
  fmtINR
} from "../../../util/helper";

import {
  getInstruments,
  getExpiries,
  getPrice,
  getOptionChainInstrumentsData,
  getTicksData,
  getworldtimeapi,
  getHolidays,
  getOptionChainInstrumentsWithoutDispatch
} from "../../../redux/actions/optionChain";

import { Container, Paper, Typography, Grid, Box } from "@material-ui/core";

// material-ui
import { Card } from "react-bootstrap";

import Centrifuge from "centrifuge";
import moment from "moment";

import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
// import ListOrdersCom from "./orders/ListOrders";
// import CloseOrdersCom from "./orders/closedOrder";
// import Trades from "./orders/trades";
// import ClosedOrder from "./orders/closedOrder";
// import Logs from "./orders/logs";
import ListPositions from "./orders/listPositions";
import PositionsAction from "../positionPage/positionsAction";
import { saveBasketSLTP, saveBrokerSLTP, GetBrokerActionPnl, getBasketAction, positionsTokanAction, getFundsAction, positionsAction, positionsActionDis, saveOrders, ListOrdersAction, ListPositionsAction, placeOrdersAction, getMarginAction, positionsSyncAction, ordersSyncAction, getjwtAction, brokerSyncAction } from "../../../redux/actions/brokerAction";
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
// style constant
import ScreenAction from "../screenAction";
import settings from "../../../config";

import { useToast } from "../../../components/common/custom-toast/Toast";
// import Funds from "./orders/funds";
import { Spinner } from "react-bootstrap";
import AppContext from "../../../context/Context";
import { Button, Timeline, Tooltip } from "antd";
import { BarChart3, RefreshCw } from "lucide-react";
import PnlMtmModal from "../../common/PnlMtmModal";
import SyncBrokerModal from "../../common/SyncBrokerModal";
import ReconciliationNotification from "../../common/ReconciliationNotification";
import { exitBrokerPositionsAction, exitSelectedPositionsAction } from "../../../redux/actions/packageAction";
import LoderCom from "components/common/Loder";
import brokerService from "services/broker.service";
const exchange = "NSE";

const ListOrdersCom = React.lazy(() => import("./orders/ListOrders"));
const Trades = React.lazy(() => import("./orders/trades"));
const Logs = React.lazy(() => import("./orders/logs"));
const Funds = React.lazy(() => import("./orders/funds"));


let localStorageObj = getLocalStorageObject("columnSettings") || {
  settings: []
}
const DefColumns = [

  {
    strategyHeader: [
      {
        header: 'Basket Name',
        accessorKey: 'basketName',
        enableColumn: true,
        align: "left",
        width: 20,
        isDecimal: false

      },
      {
        header: 'PNL',
        accessorKey: 'pnl',
        enableColumn: true,
        align: "left",
        width: 20,
        isDecimal: false

      },
      {
        header: 'Unrealized',
        accessorKey: 'upnl',
        enableColumn: true,
        align: "left",
        width: 20,
        isDecimal: false

      },
      {
        header: 'Realized',
        accessorKey: 'rpnl',
        enableColumn: true,
        align: "left",
        width: 20,
        isDecimal: false

      },
      {
        header: 'Combined Premium',
        accessorKey: 'combinedPremium',
        enableColumn: true,
        align: "left",
        width: 20,
        isDecimal: false
      },
      {
        header: 'Stop Loss',
        accessorKey: 'sl',
        enableColumn: true,
        align: "left",
        width: 20,
        isDecimal: false
      },
      {
        header: 'Target',
        accessorKey: 'ta',
        enableColumn: true,
        align: "left",
        width: 20,
        isDecimal: false
      },
      {
        header: 'Trailing SL',
        accessorKey: 'trailingSL',
        enableColumn: true,
        align: "left",
        width: 20,
        isDecimal: false
      },
      {
        isDecimal: false
      },
      {
        header: 'Margin',
        accessorKey: 'margin',
        enableColumn: true,
        align: "right",
        width: 20,
        isDecimal: true
      },
      {
        header: 'ROI %',
        accessorKey: 'roi',
        enableColumn: true,
        align: "right",
        width: 20,
        isDecimal: true
      },
    ],

    positionHeader: [

      {
        header: 'Trading Symbol',
        accessorKey: 'tradingSymbol',
        enableColumn: false,
        align: "left",
        width: 100,
        isDecimal: false

      },
      {
        header: 'Display Name',
        accessorKey: 'displayName',
        enableColumn: true,
        align: "left",
        width: 120,
        isDecimal: false

      },
      {
        header: 'Instrument',
        accessorKey: 'name',
        enableColumn: true,
        align: "center",
        width: 20,
        isDecimal: false

      },
      {
        header: 'Expriy Date',
        accessorKey: 'expiry',
        enableColumn: true,
        align: "center",
        width: 100,
        isDecimal: false

      },
      {
        header: 'Strike price',
        accessorKey: 'strikePrice',
        enableColumn: true,
        align: "center",
        width: 100,
        isDecimal: true
      },
      // {
      // header: 'Basket Name',
      // accessorKey: 'basketName',
      // enableColumn: true,			 
      // align:"center"	

      // },

      {
        header: 'Instrument Type',
        accessorKey: 'instrumentType',
        enableColumn: true,
        align: "center",
        width: 100,
        isDecimal: true
      },
      {
        header: 'Product',
        accessorKey: 'product',
        enableColumn: true,
        align: "center",
        width: 100,
        isDecimal: false
      },
      {
        header: 'Net Qty',
        accessorKey: 'netQuantity',
        enableColumn: true,
        align: "center",
        width: 100,
        isDecimal: false
      },

      {
        header: 'Avg Price',
        accessorKey: 'averagePrice',
        enableColumn: true,
        align: "right",
        width: 100,
        isDecimal: true

      },
      {
        header: 'LTP',
        accessorKey: 'ltp',
        enableColumn: true,
        align: "right",
        width: 100,
        isDecimal: true
      },
      {
        header: 'Total PNL',
        accessorKey: 'totalPNL',
        enableColumn: true,
        align: "right",
        width: 100,
        isDecimal: true
      },
      {
        header: 'Stoploss',
        accessorKey: 'stopLoss',
        enableColumn: false,
        align: "right",
        width: 150,
        isDecimal: true


      },

      {
        header: 'Target',
        accessorKey: 'target',
        enableColumn: false,
        align: "right",
        width: 150,
        isDecimal: true
      },
      {
        header: 'Trailing SL',
        accessorKey: 'forEvery',
        enableColumn: false,
        align: "right",
        width: 150,
        isDecimal: true
      },
      {
        header: 'Profit Lock',
        accessorKey: 'profitLocking',
        enableColumn: false,
        align: "right",
        width: 150,
        isDecimal: true
      },
      {
        header: 'Profit Trailing',
        accessorKey: 'profitTrailing',
        enableColumn: false,
        align: "right",
        width: 150,
        isDecimal: true
      },

      {
        header: 'Risk Actions',
        accessorKey: 'riskActions',
        enableColumn: true,
        align: "center",
        width: 100,
        isDecimal: false
      },

      {
        header: 'Add',
        accessorKey: 'add',
        enableColumn: false,
        align: "center",
        width: 100,
        isDecimal: false
      },
      {
        header: 'Exit',
        accessorKey: 'exit',
        enableColumn: false,
        align: "center",
        width: 100,
        isDecimal: false
      },
      {
        header: 'Reverse',
        accessorKey: 'reverse',
        enableColumn: false,
        align: "center",
        width: 100,
        isDecimal: false
      },
      {
        header: 'Risk ON/OFF',
        accessorKey: 'riskONriskOff',
        enableColumn: false,
        align: "center",
        width: 100,
        isDecimal: false
      },
      {
        header: 'IV',
        accessorKey: 'iv',
        enableColumn: false,
        align: "right",
        width: 100,
        isDecimal: true
      },
      {
        header: 'Delta',
        accessorKey: 'delta',
        enableColumn: false,
        align: "right",
        width: 100,
        isDecimal: true
      },
      {
        header: 'Theta',
        accessorKey: 'theta',
        enableColumn: false,
        align: "right",
        width: 100,
        isDecimal: true
      },
      {
        header: 'Vega',
        accessorKey: 'vega',
        enableColumn: false,
        align: "right",
        width: 100,
        isDecimal: true
      },
      {
        header: 'Gamma',
        accessorKey: 'gamma',
        enableColumn: false,
        align: "right",
        width: 100,
        isDecimal: true
      },
      {
        header: 'Unrealized',
        accessorKey: 'unrealizedPNL',
        enableColumn: true,
        align: "right",
        width: 160,
        isDecimal: true
      },
      {
        header: 'Realized',
        accessorKey: 'realizedPNL',
        enableColumn: true,
        align: "right",
        width: 100,
        isDecimal: true
      },
      {
        header: 'Buy Qty',
        accessorKey: 'totalBuyQuantity',
        enableColumn: false,
        align: "right",
        width: 100,
        isDecimal: false
      },
      {
        header: 'Buy Avg Price',
        accessorKey: 'buyAveragePrice',
        enableColumn: false,
        align: "right",
        width: 100,
        isDecimal: true

      },
      {
        header: 'Sell Qty',
        accessorKey: 'totalSellQuantity',
        enableColumn: false,
        align: "right",
        width: 100,
        isDecimal: false
      },




      {
        header: 'Sell Avg Price',
        accessorKey: 'sellAveragePrice',
        enableColumn: false,
        align: "right",
        width: 100,
        isDecimal: true
      },


      //   {
      //     header: 'Trailling',
      //     accessorKey: 'trailling',
      //     enableColumn: true,			 
      //     align:"center",
      //     width:150,
      //     isDecimal:true	
      // },

      //  {
      // header: 'LOT',
      // accessorKey: 'lot',
      // enableColumn: true,			 
      // align:"center",
      // width:100,
      // isDecimal:false	
      //  },
      //  {
      // header: 'Risk OFF',
      // accessorKey: 'riskOff',
      // enableColumn: true,			 
      // align:"center",
      // width:100,
      // isDecimal:false	
      //  },
    ]
  },
];

const mergeColumnSettings = (defaults, saved) => {
  if (!saved?.[0]) return defaults;
  const merge = (def, sav) => def.map(d => ({
    ...d,
    enableColumn: sav?.find(s => s.accessorKey === d.accessorKey)?.enableColumn ?? d.enableColumn
  }));
  return [{
    strategyHeader: merge(defaults[0].strategyHeader, saved[0].strategyHeader),
    positionHeader: merge(defaults[0].positionHeader, saved[0].positionHeader)
  }];
};
const Position = ({ sockSource, inputValues, info, width, height, size, screenClick, screen, separatorProps, buySellClick }) => {
  const {
    config: { isDark },
  } = useContext(AppContext);
  const isDarkRef = useRef(isDark);

  useEffect(() => {
    isDarkRef.current = isDark;
  }, [isDark]);

  const dispatch = useDispatch();
  const history = useNavigate();
  const postionList = useSelector((state) => state?.orders?.positions);
  const socketJWT = useSelector((state) => state.socketJwt.data);
  const ordersList = useSelector((state) => state.orders.data);
  const posToken = useSelector((state) => state.positionToken);
  const isOrder = useSelector((state) => state.isOrder.data);
  const positionMarge = useSelector((state) => state?.orders?.positionMarge);

  const [groupingMode, setGroupingMode] = useState("None");
  const [subGroupingMode, setSubGroupingMode] = useState("None");
  const [columns, setColumns] = useState(() =>
    mergeColumnSettings(DefColumns, getLocalStorageObject("columnSettings")?.settings)
  );
  const [price, setPrice] = useState();
  const [exitType, setexitType] = useState('');
  const [source, setSource] = useState(() => { });
  const [socketOrders, setsocketOrders] = useState({});
  const [socketPosition, setsocketPosition] = useState({});
  const [socketTrade, setSocketTrade] = useState({});
  const [totalPNL, settotalPNL] = useState({});
  const [socketOrdersLogs, setsocketOrdersLogs] = useState({});
  const [tabs, setTabs] = useState(1);
  const [isFirstTime, setisFirstTime] = useState(true);
  const [isDragBasket, setisDragBasket] = useState(false);
  const [position, setposition] = useState([]);
  // const [basketSLTP, setbasketSLTP] = useState([]);
  const [brokerSLTP, setBrokerSLTP] = useState({});
  const [positionLoder, setPositionloder] = useState(false);
  const [updateBasket, setupdateBasket] = useState(false);
  const [isClosedPosition, setisClosedPosition] = useState(false);
  const positionRef = useRef([]);
  const basketSLTPRef = useRef([]);
  const brokerSLTPRef = useRef({});
  const lastBasketKeyRef = useRef("");
  const basketFetchInFlightRef = useRef(false);
  const subscriptionMap = useRef({});
  const subscriptionInnerMap = useRef({});
  const postionListRef = useRef([]);
  const orderRef = useRef([]);
  const [searchText, setSearchText] = useState("");
  const [showPnlModal, setShowPnlModal] = useState(false);
  const [showSyncModal, setShowSyncModal] = useState(false);
  const [level, setLevel] = useState("broker");
  const [checkedId, setCheckedId] = useState([]);
  const [brokerSyncStatus, setBrokerSyncStatus] = useState(null);
  const [reconciliationData, setReconciliationData] = useState({ positions: { added: [], modified: [], deleted: [] } });

  const [showReconciliation, setShowReconciliation] = useState(false);
  const groupingModeRef = useRef("None");
  const subGroupingModeRef = useRef("None");
  const fetchQueueRef = useRef(Promise.resolve());

  useEffect(() => {
    groupingModeRef.current = groupingMode;
    subGroupingModeRef.current = subGroupingMode;
  }, [groupingMode, subGroupingMode]);

  const [basketMargins, setBasketMargins] = useState({});
  const basketMarginsRef = useRef({});

  useEffect(() => {
    basketMarginsRef.current = basketMargins || {};
  }, [basketMargins]);


  const fetchAllMargins = useCallback((targetBasketIds = null) => {
    fetchQueueRef.current = fetchQueueRef.current.then(async () => {
      if (!info?.broker?.id) return;

      const currentList = postionListRef.current;
      if (!Array.isArray(currentList) || currentList.length === 0) return;

      const activeBasketsMap = {};
      currentList.forEach(pos => {
        if (pos.basketId && pos.basketId !== "undefined") {
          if (!activeBasketsMap[pos.basketId]) {
            activeBasketsMap[pos.basketId] = [];
          }
          activeBasketsMap[pos.basketId].push(pos);
        }
      });

      let basketIds = Object.keys(activeBasketsMap);
      if (targetBasketIds) {
        basketIds = basketIds.filter(id => targetBasketIds.includes(id));
      }

      for (const basketId of basketIds) {
        const activePositions = activeBasketsMap[basketId].filter(p => p.netQuantity !== 0);

        if (activePositions.length === 0) {
          setBasketMargins(prev => ({ ...prev, [basketId]: 0 }));
          continue;
        }

        try {
          const res = await brokerService.getMargin(info.broker.id, {
            orders: activePositions.map(pos => ({
              exchange: pos.instrument?.exchange || "NFO",
              variety: "REGULAR",
              validity: "DAY",
              product: pos.product || "MIS",
              orderType: "MARKET",
              transactionType: pos.netQuantity > 0 ? "BUY" : "SELL",
              quantity: Math.abs(pos.netQuantity),
              exchangeToken: pos.instrument?.exchangeToken
            }))
          });

          if (res?.code === 200 && res?.data) {
            setBasketMargins(prev => ({ ...prev, [basketId]: res.data.totalMargin || 0 }));
          }
        } catch (error) {
          console.error(`Error fetching margin for basket ${basketId}:`, error);
        }
      }
    });
  }, [info?.broker?.id]);

  useEffect(() => {
    let timer;
    if (info?.broker?.id) {
      fetchAllMargins();
      timer = setInterval(fetchAllMargins, 30000);
    }

    return () => {
      if (timer) clearInterval(timer);
    };
  }, [info?.broker?.id, fetchAllMargins]);

  const lastBasketsRef = useRef({});

  useEffect(() => {
    if (!info?.broker?.id || !positionMarge || positionMarge.length === 0) return;

    const currentSnapshot = {};
    (positionMarge || []).forEach(p => {
      if (p.basketId && p.basketId !== "undefined") {
        currentSnapshot[p.basketId] = JSON.stringify(p.data?.map(pos => ({
          t: pos.instrumentToken,
          q: pos.netQuantity
        })));
      }
    });

    const changedBaskets = Object.keys(currentSnapshot).filter(id =>
      !lastBasketsRef.current[id] || lastBasketsRef.current[id] !== currentSnapshot[id]
    );

    if (changedBaskets.length > 0) {
      fetchAllMargins(changedBaskets);
    }

    lastBasketsRef.current = currentSnapshot;
  }, [positionMarge, info?.broker?.id, fetchAllMargins]);

  const optionChainCacheRef = useRef({});
  const toast = useToast();

  const exitSelectedPositions = () => {
    if (checkedId && checkedId.length > 0) {
      exitSelectedPositionsAction(info?.broker?.id, checkedId);
      setCheckedId([]);
    }
  }

  // connecting to socket data
  useEffect(() => {

    if (socketJWT && Object.keys(socketJWT).length > 0) {
      const centrifuge = new Centrifuge(
        process.env.REACT_APP_API_TRADE_FEED,
        {
          debug: true,
          onRefresh: function (ctx, cb) {

            async function getToken() {
              await dispatch(getjwtAction());
            }
            getToken();
          }
        }

      );
      centrifuge.setToken(socketJWT.token);

      centrifuge.on("connect", function (ctx) {
        console.log(
          "Connected with client ID " + ctx.client + " over " + ctx.transport
        );
      });

      centrifuge.on("disconnect", function (ctx) {
        console.log(
          "Disconnected: " +
          ctx +
          (ctx.reconnect
            ? ", will try to reconnect"
            : ", won't try to reconnect")
        );
      });

      centrifuge.connect();
      setSource(centrifuge);
    }
  }, [socketJWT]);
  useEffect(() => {
    if (ordersList && ordersList.length > 0) {
      orderRef.current = ordersList;
    } else {
      orderRef.current = [];
    }
  }, [ordersList, updateBasket]);

  useEffect(() => {
    if (postionList && postionList.length > 0) {
      postionListRef.current = postionList;
    } else {
      postionListRef.current = [];
    }
  }, [postionList, updateBasket]);

  useEffect(() => {
    async function getListOrders() {
      const data = await dispatch(ListOrdersAction(info?.broker?.id));
    }
    if (info?.broker?.id) {
      getListOrders();

    }
  }, [info]);

  useEffect(() => {
    async function getFunds() {
      if (info?.broker?.id) {
        await dispatch(getFundsAction(info?.broker?.id));
      }
    }
    if (info?.broker?.id && tabs === 4) {
      getFunds();
    }
  }, [info?.broker?.id, tabs]);

  useEffect(() => {

    if (source && socketJWT && socketJWT && Object.keys(socketJWT).length > 0 && info) {

      var subscription = source.subscribe(socketJWT.wsId + '-' + info.broker.id, (message) => {
        const payload = message?.data || message;
        const channel = payload?.channel;

        if (!channel) return;

        if (channel === 'orders' && payload?.order) {
          if (payload.deleted) {
            removeOrder(payload.order.id);
          } else {
            updateOrders(payload.order);
          }
          return;
        }

        if (channel === 'positions' && payload?.position) {
          if (payload.deleted) {
            removePosition(payload.position.id);
          } else if (payload.position.instrumentToken) {
            updatePosition(payload.position);
          }
          return;
        }

        if (channel === 'baskets' && payload?.basket) {
          updatebasketsltp(payload.basket);
          return;
        }

        if (channel === 'trades' && payload?.trade) {
          setSocketTrade(payload);
          return;
        }

        if (channel === 'logs' && payload?.log) {
          setsocketOrdersLogs(payload.log);
          if (payload.log.silent !== true) {
            const msg = payload.log.msg?.trim();
            if (!msg) return;

            switch (payload.log.color) {
              case 'red':
                toast.error(msg);
                break;
              case 'yellow':
                toast.warning(msg, {
                  autoClose: 500,
                });
                break;
              case 'gray':
                toast.info(msg, {
                  autoClose: 500,
                });
                break;
              case 'green':
              default:
                toast.success(msg, {
                  autoClose: 500,
                });
            }
          }
          return;
        }

        if (payload?.channel === 'sync_status' && payload?.syncStatus) {
          setBrokerSyncStatus(payload.syncStatus);
          return;
        }

        if (channel === 'reconciliation' && payload?.reconciliation) {
          setReconciliationData(payload.reconciliation);
          setShowReconciliation(true);
        }

        if (payload?.broker) {
          updatebrokersltp(payload.broker);
        }
      })
        .on("unsubscribe", (e) => { })
        .on("subscribe", (e) => { })
        .on("error", (e) => {
          console.log("", e);
        });

      return () => {
        subscription.unsubscribe();
      };
    }

  }, [source, socketJWT, info]);

  useEffect(() => {
    async function getListPostion() {
      const data = await dispatch(ListPositionsAction(info?.broker?.id));

      var symbolList = [];
      if (data) {
        for (let i = 0; i < data.length; i++) {
          symbolList.push(data[i].instrumentToken);
        }


        if (data && symbolList.length) {
          margePosition(data)

        }

      } else {

        setPositionloder(false)
        getPNL({
          totalPNL: 0,
          realizedPNL: 0,
          unrealizedPNL: 0
        });
      }
    }

    if (info?.broker?.id) {
      getListPostion();

    }
  }, [info?.broker?.id, isDragBasket]);


  const margePosition = async (data, symbolList) => {
    //  const dataTick = await getTicksData(symbolList);
    if (data) {
      const dataDef = await data.map(async (item) => {
        item.ltp = 0//dataTick[item.instrumentToken]?.lp || 0;
        item.realizedPNL = 0//calculatePositionRealisedPnl(item);
        item.unrealizedPNL = 0//parseFloat(calculatePositionUnrealisedPnl(item, dataTick[item.instrumentToken]?.lp));
        item.totalPNL = 0//parseFloat(calculatePositionRealisedPnl(item)) + parseFloat(calculatePositionUnrealisedPnl(item, dataTick[item.instrumentToken]?.lp));

        if (item.instrument) {
          if (item.instrument.name && item.instrument.expiry) {
            item.risk = {}//await fetchOptionChainInstruments(item);
            item.riskltp = {}// await fetchSymbolData([item.risk.ceRiskONToken, item.risk.peRiskONToken, item.risk.peRiskONTokenUpper, item.risk.ceRiskONTokenUpper]);
          }
        }

        return item;
      })

      Promise.all(dataDef).then((data) => {


        const itemsObject = data.reduce((accumulator, currentValue) => {


          if (accumulator[currentValue.basketId]) {
            accumulator[currentValue.basketId].push(currentValue)
          } else {
            accumulator[currentValue.basketId] = [currentValue]
          }
          return accumulator
        }, {})

        const resultWithBasket = Object.keys(itemsObject).filter((item) => item !== "undefined").map(k => ({
          basketId: k,
          data: itemsObject[k],
          open: itemsObject[k].filter((item) => item.netQuantity != 0).length,
          close: itemsObject[k].length
        }))
        const resultWithOutBasket = Object.keys(itemsObject).filter((item) => item === "undefined").map(k => ({ basketId: k, data: itemsObject[k] }))
        const result = Object.keys(itemsObject).map(k => ({ basketId: k, data: itemsObject[k] }))

        // setposition([...resultWithBasket, ...resultWithOutBasket]);
        setPositionloder(false)
        dispatch(positionsActionDis([...resultWithBasket, ...resultWithOutBasket]))

        var instrumentToken = []
        var positions = [];
        var symbols = [];
        var positionRef = [...resultWithBasket, ...resultWithOutBasket];
        for (let i = 0; i < positionRef.length; i++) {
          var dataP = positionRef[i].data;
          for (let j = 0; j < dataP.length; j++) {
            positions.push(dataP[j])
            instrumentToken.push(dataP[j].instrumentToken)
            var filter = symbols.filter((item) => item.name === dataP[j].instrument.name && item.expiry === dataP[j].instrument.expiry);

            if (filter.length === 0) {
              symbols.push(dataP[j].instrument)
            }
          }
        }

        getData(positions, instrumentToken, symbols)
      })


    } else {

      setPositionloder(false)
    }
  }

  async function getData(positions, instrumentToken, symbols) {
    var instrumentDetail = [];
    const dataTick = await getTicksData(instrumentToken);
    var optiCnchainInstruments = {};

    const uniqueSymbols = symbols || [];

    const uncachedSymbols = uniqueSymbols.filter(sym => !optionChainCacheRef.current[sym.name + "-" + sym.expiry]);
    const cachedSymbols = uniqueSymbols.filter(sym => optionChainCacheRef.current[sym.name + "-" + sym.expiry]);

    cachedSymbols.forEach(sym => {
      const key = sym.name + "-" + sym.expiry;
      optiCnchainInstruments[key] = optionChainCacheRef.current[key];
    });

    if (uncachedSymbols.length > 0) {
      console.log(`Fetching option chain for ${uncachedSymbols.length} new symbols:`, uncachedSymbols.map(s => s.name));

      const ocResults = await Promise.allSettled(
        uncachedSymbols.map((sym) => fetchOptionChainInstruments(sym))
      );

      ocResults.forEach((res, idx) => {
        const sym = uncachedSymbols[idx];
        const key = sym.name + "-" + sym.expiry;
        if (sym && res.status === 'fulfilled' && res.value) {
          optiCnchainInstruments[key] = res.value;
          optionChainCacheRef.current[key] = res.value;
        }
      });
    } else {
      console.log('All symbols found in cache, no API calls needed');
    }

    const withRisk = await Promise.all((positions || []).map(async (item) => {
      const tick = dataTick[item.instrumentToken] || {};
      const lp = tick.lp || 0;
      const qty = Number(item.netQuantity || 0);
      item.ltp = lp;
      item.iv = Number(tick.iv || 0);
      item.delta = Number(tick.d || 0) * qty;
      item.theta = Number(tick.t || 0) * qty;
      item.vega = Number(tick.ve || 0) * qty;
      item.gamma = Number(tick.g || 0) * qty;

      item.realizedPNL = calculatePositionRealisedPnl(item);
      item.unrealizedPNL = parseFloat(calculatePositionUnrealisedPnl(item, lp));
      item.totalPNL = parseFloat(calculatePositionRealisedPnl(item)) + parseFloat(calculatePositionUnrealisedPnl(item, lp));
      if (item.instrument && item.instrument.name && item.instrument.expiry) {
        const key = item.instrument.name + "-" + item.instrument.expiry;
        item.risk = await getRiskOnOff(optiCnchainInstruments[key], item.instrument);
      }
      return item;
    }));

    const riskTokenSet = new Set();
    for (let i = 0; i < withRisk.length; i++) {
      const r = withRisk[i]?.risk || {};
      if (r.ceRiskONToken) riskTokenSet.add(r.ceRiskONToken);
      if (r.peRiskONToken) riskTokenSet.add(r.peRiskONToken);
      if (r.peRiskONTokenUpper) riskTokenSet.add(r.peRiskONTokenUpper);
      if (r.ceRiskONTokenUpper) riskTokenSet.add(r.ceRiskONTokenUpper);
    }

    let riskTicks = {};
    if (riskTokenSet.size > 0) {
      riskTicks = await getTicksData(Array.from(riskTokenSet));
    }

    const finalized = withRisk.map((item) => {
      const r = item?.risk || {};
      const keys = [r.ceRiskONToken, r.peRiskONToken, r.peRiskONTokenUpper, r.ceRiskONTokenUpper].filter(Boolean);
      const obj = {};
      keys.forEach((k) => { obj[k] = riskTicks[k]; })
      item.riskltp = obj;
      return item;
    });

    var totalPNL = 0;
    var realizedPNL = 0;
    var unrealizedPNL = 0;
    for (let i = 0; i < finalized.length; i++) {
      totalPNL += parseFloat(finalized[i].totalPNL);
      realizedPNL += parseFloat(finalized[i].realizedPNL);
      unrealizedPNL += parseFloat(finalized[i].unrealizedPNL);
    }

    getPNL({
      totalPNL: totalPNL,
      realizedPNL: realizedPNL,
      unrealizedPNL: unrealizedPNL
    });
  }


  async function fetchOptionChainInstruments(rowData) {
    const res = await getOptionChainInstrumentsWithoutDispatch(
      rowData.name,
      rowData.expiry.split("T")[0],
    );
    const { optData, futToken: futTkn } = res;
    if (optData) {
      //setOptionChainInstrumentsData(optData);

      if (optData && optData.length > 0) {

        return optData;

      }
    }
  }

  async function getRiskOnOff(optData, rowData) {
    const { symbolList, symbolsToStrikePrice, strikeList } = getSymbolList(
      optData,
    );


    // setsymbolsToStrikePrice(symbolsToStrikePrice);
    // setsymbolList(symbolList);
    // setstrikeList(strikeList)
    var index = strikeList.indexOf(rowData.strikePrice);
    var value = {};
    if (rowData.instrumentType === "CE") {
      value = {
        ceRiskON: strikeList[index - 1],
        ceRiskOFF: strikeList[index + 1],

        ceRiskONUpper: strikeList[index - 2],
        ceRiskOFFUpper: strikeList[index + 2],

        ceRiskONToken: symbolsToStrikePrice[strikeList[index - 1]]?.CE,
        peRiskONToken: symbolsToStrikePrice[strikeList[index + 1]]?.CE,

        ceRiskONTokenUpper: symbolsToStrikePrice[strikeList[index - 2]]?.CE,
        peRiskONTokenUpper: symbolsToStrikePrice[strikeList[index + 2]]?.CE,

        ceRiskONsymbol: symbolsToStrikePrice[strikeList[index - 1]],
        ceRiskOFFsymbol: symbolsToStrikePrice[strikeList[index + 1]],

        ceRiskONsymbolUpper: symbolsToStrikePrice[strikeList[index - 2]],
        ceRiskOFFsymbolUpper: symbolsToStrikePrice[strikeList[index + 2]]
      };
    } else if (rowData.instrumentType === "PE") {

      value = {
        peRiskON: strikeList[index + 1],
        peRiskOFF: strikeList[index - 1],

        peRiskONUpper: strikeList[index + 2],
        peRiskOFFUpper: strikeList[index - 2],

        ceRiskONToken: symbolsToStrikePrice[strikeList[index + 1]]?.PE,
        peRiskONToken: symbolsToStrikePrice[strikeList[index - 1]]?.PE,

        ceRiskONTokenUpper: symbolsToStrikePrice[strikeList[index + 2]]?.PE,
        peRiskONTokenUpper: symbolsToStrikePrice[strikeList[index - 2]]?.PE,

        peRiskONsymbol: symbolsToStrikePrice[strikeList[index + 1]],
        peRiskOFFsymbol: symbolsToStrikePrice[strikeList[index - 1]],

        peRiskONsymbolUpper: symbolsToStrikePrice[strikeList[index + 2]],
        peRiskOFFsymbolUpper: symbolsToStrikePrice[strikeList[index - 2]]
      };

    }
    return value;
  }

  async function fetchSymbolData(
    token,
  ) {

    const data = await getTicksData(token);
    return data;
  }

  const getSymbolList = (optionData) => {
    let symbolList = [];
    let strikeList = new Set();
    let symbolsToStrikePrice = {};

    for (let i = 0; i < optionData.length; i++) {
      symbolList.push(optionData[i]?.instrumentToken);

      const obj = symbolsToStrikePrice[optionData[i]?.strikePrice] || {};

      obj[optionData[i]?.instrumentType] = optionData[i]?.instrumentToken;
      obj['exchangeToken-' + optionData[i]?.instrumentType] = optionData[i]?.exchangeToken;
      obj['tradingSymbol-' + optionData[i]?.instrumentType] = optionData[i]?.tradingSymbol;
      obj['exchange-' + optionData[i]?.instrumentType] = optionData[i]?.exchange;
      obj['lotSize-' + optionData[i]?.instrumentType] = optionData[i]?.lotSize;
      obj['displayName-' + optionData[i]?.instrumentType] = optionData[i]?.displayName;
      symbolsToStrikePrice[optionData[i]?.strikePrice] = obj;
      strikeList.add(optionData[i]?.strikePrice);
    }

    return { symbolList, symbolsToStrikePrice, strikeList: [...strikeList] };
  };


  const updatebasketsltp = (data) => {
    if (basketSLTPRef?.current) {
      var index = basketSLTPRef?.current?.findIndex((item) => item.id === data?.id);
      if (index != -1) {
        basketSLTPRef.current = [
          ...basketSLTPRef.current.slice(0, index),
          data,
          ...basketSLTPRef.current.slice(index + 1)
        ];
      } else {
        basketSLTPRef.current = [...basketSLTPRef.current, data];
      }
    }

    dispatch(saveBasketSLTP(basketSLTPRef.current))
  }




  const updatebrokersltp = (data) => {
    if (brokerSLTPRef?.current) {
      brokerSLTPRef.current = data;
      dispatch(saveBrokerSLTP(brokerSLTPRef.current))
    }
  }

  const updatePosition = async (socketPosition) => {
    if (socketPosition && Object.keys(socketPosition).length > 0) {
      const positionIndex = postionListRef?.current?.findIndex(
        (item) => item.id === socketPosition.id
      );
      if (positionIndex === -1) {
        postionListRef.current = [...postionListRef.current, socketPosition];
        dispatch(positionsAction(postionListRef.current))
      } else {
        postionListRef.current = [
          ...postionListRef.current.slice(0, positionIndex),
          socketPosition,
          ...postionListRef.current.slice(positionIndex + 1)
        ];
        dispatch(positionsAction(postionListRef.current))
      }
      if (postionListRef.current && postionListRef.current.length > 0) {
        var symbolList = [];
        for (let i = 0; i < postionListRef.current.length; i++) {
          symbolList.push(postionListRef.current[i].instrumentToken);
        }

        if (symbolList.length) {
          if (window.margePositionTimeout) {
            clearTimeout(window.margePositionTimeout);
          }
          window.margePositionTimeout = setTimeout(() => {
            margePosition(postionListRef.current, symbolList);
          }, 100);
        }
      }
      setupdateBasket((updateBasket) => !updateBasket);

    }
  }

  const removePosition = (positionId) => {
    const positionIndex = postionListRef?.current?.findIndex(
      (item) => item.id === positionId
    );
    if (positionIndex !== -1) {
      postionListRef.current = [
        ...postionListRef.current.slice(0, positionIndex),
        ...postionListRef.current.slice(positionIndex + 1)
      ];
      dispatch(positionsAction(postionListRef.current))
      if (postionListRef.current && postionListRef.current.length >= 0) {
        var symbolList = [];
        for (let i = 0; i < postionListRef.current.length; i++) {
          symbolList.push(postionListRef.current[i].instrumentToken);
        }
        if (window.margePositionTimeout) {
          clearTimeout(window.margePositionTimeout);
        }
        window.margePositionTimeout = setTimeout(() => {
          margePosition(postionListRef.current, symbolList);
        }, 100);
      }
      setupdateBasket((updateBasket) => !updateBasket);
    }
  };

  const updateOrders = (socketOrders) => {
    if (socketOrders && Object.keys(socketOrders).length > 0) {
      //if(socketOrders.status) {
      var findIndex = orderRef.current.findIndex((item) => item.id === socketOrders.id);

      if (findIndex === -1) {
        orderRef.current = [socketOrders].concat(orderRef.current);
        dispatch(saveOrders(orderRef.current))
      } else {
        orderRef.current[findIndex] = socketOrders;
        dispatch(saveOrders(orderRef.current))

      }
    }
  }

  const removeOrder = (orderId) => {
    var findIndex = orderRef.current.findIndex((item) => item.id === orderId);
    if (findIndex !== -1) {
      orderRef.current = [
        ...orderRef.current.slice(0, findIndex),
        ...orderRef.current.slice(findIndex + 1)
      ];
      dispatch(saveOrders(orderRef.current));
    }
  };

  useEffect(() => {
    // subscribe for socket data

    async function saveSLTP(positionMarge) {
      const uniqueIds = Array.from(new Set((positionMarge || []).map((p) => p.basketId).filter((id) => id && id !== "undefined")));
      const key = uniqueIds.sort().join(',');
      if (basketFetchInFlightRef.current) return;
      if (key === lastBasketKeyRef.current) return;
      basketFetchInFlightRef.current = true;
      lastBasketKeyRef.current = key;
      try {
        var sltp = [];
        if (uniqueIds.length > 0) {
          const results = await Promise.allSettled(uniqueIds.map((id) => dispatch(getBasketAction(id))));
          results.forEach((res) => {
            if (res.status === 'fulfilled' && res.value?.status && res.value?.data) {
              const data = res.value.data;
              var index = sltp.findIndex((item) => item.id === data?.id)
              if (index === -1) {
                sltp.push(data)
              } else {
                sltp[index] = data;
              }
            }
          })
        }
        await dispatch(saveBasketSLTP(sltp))
        basketSLTPRef.current = sltp;
      } finally {
        basketFetchInFlightRef.current = false;
      }
    }
    if (
      positionMarge &&
      positionMarge.length
    ) {
      saveSLTP(positionMarge);
    }
  }, [positionMarge]);

  useEffect(() => {

    async function getBrokersltp() {
      const data = await dispatch(GetBrokerActionPnl(info?.broker?.id));

      if (data.status) {

        setBrokerSLTP(data.data);
        brokerSLTPRef.current = data.data;
      }
    }
    if (info?.broker?.id) {
      getBrokersltp(info?.broker?.id);
    }

  }, [info, positionMarge]);

  useEffect(() => {
    unsubscribeToken();
    if (
      sockSource &&
      Object.keys(sockSource).length > 0 &&
      positionMarge &&
      positionMarge.length
    ) {

      subscriptionMap.current = {};
      positionMarge.forEach((item, pIndex) => {
        item?.data?.forEach((token, index) => {


          //if(token.netQuantity != 0) {

          var subscription1 = sockSource
            .subscribe(token.instrumentToken + "", (message) =>
              handleResponse(
                message,
                pIndex,
                index,
                token.instrumentToken,
                token.basketId,
                token.netQuantity
              )
            )
            .on("unsubscribe", (unsubscribe) => {

            })
            .on("subscribe", () => { })
            .on("error", handleSubscribeError);
          subscriptionMap.current[token.instrumentToken] = subscription1;
        });
      });
      dispatch(positionsTokanAction(subscriptionMap.current));
      //localStorage.setItem("pos-token", JSON.stringify(subscriptionMap.current));

      // setLocalStorageObject('pos-token', "tokens", subscriptionMap.current, localStorageObj);
    }
  }, [sockSource, positionMarge, updateBasket, info, tabs]);

  const handleResponse = (
    message,
    pIndex,
    index,
    token,
    basketId,
    netQuantity
  ) => {

    // console.log("message=>", message.data)
    if (
      positionMarge[pIndex] &&
      positionMarge[pIndex].data[index]
    ) {
      const pos = positionMarge[pIndex].data[index];
      const lp = Number(message?.data?.lp || 0);
      const deltaRaw = message?.data?.d != null ? Number(message?.data?.d) : undefined;
      const gammaRaw = message?.data?.g != null ? Number(message?.data?.g) : undefined;
      const thetaRaw = message?.data?.t != null ? Number(message?.data?.t) : undefined;
      const vegaRaw = message?.data?.ve != null ? Number(message?.data?.ve) : undefined;
      const ivRaw = message?.data?.iv != null ? Number(message?.data?.iv) : undefined;
      const qty = Number(netQuantity || 0);

      pos.ltp = lp.toFixed(2);
      pos.realizedPNL = calculatePositionRealisedPnl(pos);
      pos.unrealizedPNL = parseFloat(calculatePositionUnrealisedPnl(pos, lp));
      pos.totalPNL = parseFloat(calculatePositionRealisedPnl(pos)) + parseFloat(calculatePositionUnrealisedPnl(pos, lp));

      if (deltaRaw !== undefined) pos.delta = deltaRaw * qty;
      if (gammaRaw !== undefined) pos.gamma = gammaRaw * qty;
      if (thetaRaw !== undefined) pos.theta = thetaRaw * qty;
      if (vegaRaw !== undefined) pos.vega = vegaRaw * qty;
      if (ivRaw !== undefined) pos.iv = ivRaw;

      var ltpdiv = document.getElementById("ltp-" + token + "-" + basketId) || document.getElementById("ltp-" + token);
      var realizedPNLdiv = document.getElementById("realizedPNL-" + token + "-" + basketId);
      var unrealizedPNLdiv = document.getElementById("unrealizedPNL-" + token + "-" + basketId);
      var totalPNLdiv = document.getElementById("totalPNL-" + token + "-" + basketId);

      var deltadiv = document.getElementById("delta-" + token + "-" + basketId);
      var gammadiv = document.getElementById("gamma-" + token + "-" + basketId);
      var thetadiv = document.getElementById("theta-" + token + "-" + basketId);
      var vegadiv = document.getElementById("vega-" + token + "-" + basketId);
      var ivdiv = document.getElementById("iv-" + token + "-" + basketId);

      if (ltpdiv) {
        ltpdiv.innerText = lp.toFixed(2);
      }

      const updateGreekDiv = (div, val, decimals = 2, skipColor = false) => {
        if (div && val !== undefined) {
          div.innerText = Number(val).toFixed(decimals);
          if (!skipColor) {
            addColor(val, div.id);
          } else {
            div.style.removeProperty("color");
          }
        }
      };

      updateGreekDiv(deltadiv, pos.delta);
      updateGreekDiv(gammadiv, pos.gamma, 4);
      updateGreekDiv(thetadiv, pos.theta);
      updateGreekDiv(vegadiv, pos.vega);
      updateGreekDiv(ivdiv, pos.iv, 2, true);

      if (realizedPNLdiv) {
        realizedPNLdiv.innerText = fmtINR(
          pos?.realizedPNL
        );
        addColor(
          pos?.realizedPNL,
          "realizedPNL-" + token + "-" + basketId
        );
      }
      if (unrealizedPNLdiv) {
        unrealizedPNLdiv.innerText = fmtINR(
          pos?.unrealizedPNL
        );
        addColor(
          pos?.unrealizedPNL,
          "unrealizedPNL-" + token + "-" + basketId
        );
      }
      if (totalPNLdiv) {
        totalPNLdiv.innerText = fmtINR(
          pos?.totalPNL
        );
        addColor(
          pos?.totalPNL,
          "totalPNL-" + token + "-" + basketId
        );
      }

      let postions = positionMarge[pIndex].data;
      let currentBasketId =
        positionMarge[pIndex].basketId === "undefined"
          ? "Positions"
          : positionMarge[pIndex].basketId;
      let basketTotPNL = 0;
      let basketTotR = 0;
      let basketTotU = 0;
      let combPrem = 0;
      let basketName;

      let buyPremium = 0;
      let sellPremium = 0;
      const basketConfig = (basketSLTPRef.current || []).find(b => b.id === currentBasketId);
      const usePerLot = !!basketConfig?.rms?.perLot;

      for (let i = 0; i < postions.length; i++) {
        basketTotPNL += parseFloat(postions[i].totalPNL);
        basketTotR += parseFloat(postions[i].realizedPNL);
        basketTotU += parseFloat(postions[i].unrealizedPNL);

        const pos = postions[i];
        const netQty = parseFloat(pos.netQuantity || 0);
        const qty = Math.abs(netQty);
        const lotSize = parseFloat(pos.instrument?.lotSize);
        const lots = lotSize > 0 ? qty / lotSize : qty;
        const ltp = parseFloat(pos.ltp || 0);
        if (lots !== 0) {
          if (usePerLot) {
            if (netQty > 0) {
              buyPremium += ltp;
            } else {
              sellPremium += ltp;
            }
          } else {
            if (netQty > 0) {
              buyPremium += ltp * lots;
            } else {
              sellPremium += ltp * lots;
            }
          }
        }
      }
      combPrem = buyPremium - sellPremium;

      var basketTotPNLdiv = document.getElementById(currentBasketId + "-pnl");
      var basketTotRdiv = document.getElementById(currentBasketId + "-r");
      var basketTotUdiv = document.getElementById(currentBasketId + "-u");
      var combPremdiv = document.getElementById(currentBasketId + "-comb-prem");
      var basketPoptPNLdiv = document.getElementById(currentBasketId + "-pop-pnl");
      var combPremPop = document.getElementById(currentBasketId + "-comb-prm");
      if (combPremdiv) {
        combPremdiv.innerText = combPrem.toFixed(2);
      }

      if (basketPoptPNLdiv) {
        basketPoptPNLdiv.innerText = fmtINR(basketTotPNL);
        addColor(basketTotPNL, currentBasketId + "-pop-pnl");
      }

      if (combPremPop) {
        combPremPop.innerText = combPrem.toFixed(2);
      }


      if (basketTotPNLdiv) {
        basketTotPNLdiv.innerText = fmtINR(basketTotPNL) //.toFixed(2);
        addColor(basketTotPNL, currentBasketId + "-pnl");

        const basketTotROIdiv = document.getElementById(currentBasketId + "-roi");
        const currentMargin = basketMarginsRef.current[currentBasketId];
        if (basketTotROIdiv && currentMargin && currentMargin > 0) {
          const roi = (basketTotPNL / currentMargin) * 100;
          basketTotROIdiv.innerText = roi.toFixed(2) + "%";
          addColor(roi, currentBasketId + "-roi");
        }
      }

      if (basketTotRdiv) {
        basketTotRdiv.innerText = fmtINR(basketTotR) //.toFixed(2);
        addColor(basketTotR, currentBasketId + "-r");
      }
      if (basketTotUdiv) {
        basketTotUdiv.innerText = fmtINR(basketTotU) //.toFixed(2);
        addColor(basketTotU, currentBasketId + "-u");
      }

      // Real-time Group-level Updates (Instrument/Expiry/Strike/BuySell)
      if (currentBasketId === "Positions") {
        const groupStats = {};

        const getModeKey = (item, mode) => {
          if (mode === "Instrument") return item.instrument?.name || "Unknown";
          if (mode === "Expiry Date") return item.instrument?.expiry ? moment(item.instrument.expiry).format("DD-MMM-YY") : "Unknown";
          if (mode === "Strike Price") return item.instrument?.strikePrice ? fmt(item.instrument.strikePrice) : "Unknown";
          if (mode === "Buy/Sell") return item.netQuantity > 0 ? "Buy" : item.netQuantity < 0 ? "Sell" : "Neutral";
          return "Unknown";
        }


        const sanitize = (str) => String(str).replace(/[^a-zA-Z0-9]/g, '');

        if (groupingModeRef.current !== "None") {
          positionMarge[pIndex].data.forEach(item => {
            const L1Name = getModeKey(item, groupingModeRef.current);
            const L1Key = sanitize(groupingModeRef.current) + "-" + sanitize(L1Name);

            if (!groupStats[L1Key]) {
              groupStats[L1Key] = { total: 0, r: 0, u: 0, open: 0, count: 0 };
            }
            groupStats[L1Key].total += parseFloat(item.totalPNL || 0);
            groupStats[L1Key].r += parseFloat(item.realizedPNL || 0);
            groupStats[L1Key].u += parseFloat(item.unrealizedPNL || 0);
            groupStats[L1Key].count++;
            if (item.netQuantity != 0) groupStats[L1Key].open++;

            if (subGroupingModeRef.current !== "None") {
              const L2Name = getModeKey(item, subGroupingModeRef.current);
              const L2Key = L1Key + "-" + sanitize(subGroupingModeRef.current) + "-" + sanitize(L2Name);

              if (!groupStats[L2Key]) {
                groupStats[L2Key] = { total: 0, r: 0, u: 0, open: 0, count: 0 };
              }
              groupStats[L2Key].total += parseFloat(item.totalPNL || 0);
              groupStats[L2Key].r += parseFloat(item.realizedPNL || 0);
              groupStats[L2Key].u += parseFloat(item.unrealizedPNL || 0);
              groupStats[L2Key].count++;
              if (item.netQuantity != 0) groupStats[L2Key].open++;
            }
          });


          Object.keys(groupStats).forEach(key => {
            const stats = groupStats[key];
            const gpnl = document.getElementById("group-pnl-" + key);
            const gr = document.getElementById("group-r-" + key);
            const gu = document.getElementById("group-u-" + key);
            const gcount = document.getElementById("group-count-" + key);

            if (gpnl) {
              gpnl.innerText = fmtINR(stats.total);
              addColor(stats.total, gpnl.id);
            }
            if (gr) {
              gr.innerText = fmtINR(stats.r);
              addColor(stats.r, gr.id);
            }
            if (gu) {
              gu.innerText = fmtINR(stats.u);
              addColor(stats.u, gu.id);
            }
            if (gcount) {
              gcount.innerText = `(${stats.open}/${stats.count})`;
            }
          });
        }
      }
    }

    var tolPNLdiv = document.getElementById("total-pnl");

    var tolrealizedPNLdiv = document.getElementById("total-realized");
    var tolunrealizedPNLdiv = document.getElementById("total-unrealized");
    var brokerPNLdiv = document.getElementById("broker-pop-pnl");

    var toptolPNLdiv = document.getElementById("top-total-pnl");
    var toptolunrealizedPNLdiv = document.getElementById("top-total-unrealized");

    let basketPostions = positionMarge;
    var totalPNL = 0;
    var tolrealizedPNL = 0;
    var tolunrealizedPNL = 0;



    var singletolPNLdiv = document.getElementById("single-l-s-pnl");
    var singletolunrealizedPNLdiv = document.getElementById("single-l-s-u");
    var singletolrealizedPNLdiv = document.getElementById("single-l-s-r");

    var singletotalPNL = 0;
    var singletolunrealizedPNL = 0;
    var singletolrealizedPNL = 0;

    for (let i = 0; i < basketPostions.length; i++) {
      var pos = basketPostions[i].data;
      //  console.log("basketPostions", basketPostions[i])

      for (let j = 0; j < pos.length; j++) {
        // if (!isNaN(parseFloat(pos[j].totalPNL))) {
        totalPNL += parseFloat(pos[j].totalPNL);
        tolrealizedPNL += parseFloat(pos[j].realizedPNL);
        tolunrealizedPNL += parseFloat(pos[j].unrealizedPNL);
        // }
      }
      if (basketPostions[i].basketId !== "undefined") {
        var posWithBasket = basketPostions[i].data;
        let buyPrem = 0;
        let sellPrem = 0;
        for (let j = 0; j < posWithBasket.length; j++) {
          const pb = posWithBasket[j];
          const netQty = parseFloat(pb.netQuantity || 0);
          const qty = Math.abs(netQty);
          const lotSize = parseFloat(pb.instrument?.lotSize);
          const lots = lotSize > 0 ? qty / lotSize : qty;
          const ltp = parseFloat(pb.ltp || 0);
          if (lots !== 0) {
            if (netQty > 0) {
              buyPrem += ltp * lots;
            } else {
              sellPrem += ltp * lots;
            }
          }
        }
        var totalLTP = buyPrem - sellPrem;
        if (
          document.getElementById("comb-prem-" + basketPostions[i].basketId)
        ) {
          document.getElementById(
            "comb-prem-" + basketPostions[i].basketId
          ).value = totalLTP.toFixed(2);
        }
      }

      if (basketPostions[i].basketId === "undefined") {
        var poSingle = basketPostions[i].data;
        for (let j = 0; j < poSingle.length; j++) {
          if (!isNaN(parseFloat(poSingle[j].totalPNL))) {
            singletotalPNL += parseFloat(poSingle[j].totalPNL);
            singletolunrealizedPNL += parseFloat(poSingle[j].unrealizedPNL);
            singletolrealizedPNL += parseFloat(poSingle[j].realizedPNL);
          }
        }
      }
    }

    if (tolPNLdiv) {
      tolPNLdiv.innerHTML = fmtINR(totalPNL); //.toFixed(2);
      addColor(totalPNL, "total-pnl");
    }
    if (brokerPNLdiv) {
      brokerPNLdiv.innerHTML = fmtINR(totalPNL); //.toFixed(2);
      addColor(totalPNL, "broker-pop-pnl");
    }
    if (toptolPNLdiv) {
      toptolPNLdiv.innerHTML = fmtINR(totalPNL); //.toFixed(2);
      addColor(totalPNL, "top-total-pnl");
    }

    if (tolrealizedPNLdiv) {
      tolrealizedPNLdiv.innerText = fmtINR(tolrealizedPNL) //.toFixed(2);
      addColor(tolrealizedPNL, "total-realized");
    }
    if (tolunrealizedPNLdiv) {
      tolunrealizedPNLdiv.innerText = fmtINR(tolunrealizedPNL); //.toFixed(2);
      addColor(tolunrealizedPNL, "total-unrealized");
    }

    if (toptolunrealizedPNLdiv) {
      toptolunrealizedPNLdiv.innerText = fmtINR(tolunrealizedPNL); //.toFixed(2);
      addColor(tolunrealizedPNL, "top-total-unrealized");
    }

    if (singletolPNLdiv) {
      singletolPNLdiv.innerHTML = fmtINR(singletotalPNL) //.toFixed(2);
      addColor(singletotalPNL, "single-l-s-pnl");
    }
    if (singletolunrealizedPNLdiv) {
      singletolunrealizedPNLdiv.innerText =
        fmtINR(singletolunrealizedPNL) //.toFixed(2);
      addColor(singletolunrealizedPNL, "single-l-s-u");
    }
    if (singletolrealizedPNLdiv) {
      singletolrealizedPNLdiv.innerText = fmtINR(singletolrealizedPNL) //.toFixed(2);

      addColor(singletolrealizedPNL, "single-l-s-r");
    }
    // }
    // }
  };
  // addColor now uses global isDark
  const addColor = (val, id) => {
    const el = document.getElementById(id);
    if (!el) return;
    if (val > 0) {
      el.style.setProperty("color", isDarkRef.current ? "#00d27a" : "#16a34a", "important");
    } else if (val < 0) {
      el.style.setProperty("color", isDarkRef.current ? "#F87171" : "#E74C3C", "important");
    } else {
      el.style.removeProperty("color");
    }
  };

  function handleSubscribeError(err) {
    console.log("Error subscribing on channel symbol ", err);
  }
  //  console.log("posToken", posToken)

  const unsubscribeToken = () => {
    if (posToken && Object.keys(posToken).length > 0) {
      Object.keys(posToken).forEach((token, index) => {
        if (posToken[token]) {
          posToken[token]?.unsubscribe();
        }
      });
      dispatch(positionsTokanAction({}));
    }
    return true;
  };
  const exitOrders = (type) => {
    setexitType(type);

    const filterOrder = postionList?.filter((item) => (item.displayName.split(' ')[item.displayName.split(' ').length - 1] === type || type === "ALL"));

    const orders = filterOrder?.map((item) => {
      const transactionType = item.netQuantity > 0 ? 'SELL' : 'BUY';
      var price = 0

      if (inputValues.orderType === "MARKET PROTECT") {
        const CalculatemarketProtect = (item.ltp * (inputValues.marketProtect / 100));
        price = transactionType === "BUY" ? item.ltp + CalculatemarketProtect : item.ltp - CalculatemarketProtect
      }
      const orderParam = {
        exchange: item.exchange,
        variety: "REGULAR",
        validity: inputValues.validity,
        product: inputValues.product,
        orderType: inputValues.orderType === "MARKET PROTECT" ? "LIMIT" : inputValues.orderType,
        transactionType: transactionType,
        quantity: item.netQuantity,
        price: price,
        exchangeToken: item.exchangeToken,
        disclosedQuantity: 0,
        stopLossPrice: 0,
        targetPrice: 0,
        trailReferencePoints: 0,
        trailStepPoints: 0,

      };
      const order = {
        basketName: item.basketName,
        stopLossAbsolute: 0,
        takeProfitAbsolute: 0,
        trailReferenceAbsolute: 0,
        trailStepAbsolute: 0,
        orders: [orderParam]
      };
      placeOrders(order);
    })



  }

  const placeOrders = (order, user) => {
    async function funplaceOrders(order) {
      await dispatch(placeOrdersAction(order, info?.broker?.id));
    }

    funplaceOrders(order, user);
  };

  const refresh = () => {
    setBrokerSyncStatus(null);
    setShowSyncModal(true);
  }

  const startSyncProgress = () => {
    setShowSyncModal(false);
  }

  const getPNL = (value) => {

    settotalPNL(value);
  }

  const socketupdated = () => {
    setsocketPosition({})
  }

  const tabClick = (type) => {
    setTabs(type)
  }

  const loadPage = () => {
    setisFirstTime(false)
  }

  const getPositionCount = (data) => {
    let sum = 0;
    if (data) {
      for (let i = 0; i < data.length; i++) {
        sum += data[i].data.filter((item) => item.netQuantity != 0).length || 0;
      }
    }

    return sum;
  }

  const exitCE = () => {
    exitBrokerPositionsAction(info?.broker?.id, "CE");
  }

  const exitPE = () => {
    exitBrokerPositionsAction(info?.broker?.id, "PE");
  }

  const exitALL = () => {
    exitBrokerPositionsAction(info?.broker?.id, "");
  }





  const placeOrder = async (order, basketId) => {
    if (order.length === 0) {
      return;
    }
    const param = {
      "basketName": "",
      ignoreBasketMove: true,
      "basketId": basketId != "undefined" ? basketId : "",
      "stopLossAbsolute": null,
      "takeProfitAbsolute": null,
      "trailReferenceAbsolute": null,
      "trailStepAbsolute": null,
      "orders": order
    }


    await dispatch(placeOrdersAction(param, info?.broker?.id));
  }



  return (
    <div
      style={{
        width,
        height: "100%",
      }}
      className="opt-chn-tbl"
    >
      <Card.Body className="p-1">
        <div className="tabs-container d-flex justify-content-between px-1 mb-2 position-relative">
          <Tabs defaultIndex={0} style={{ width: "100%" }}>
            <TabList>
              <Tab onClick={() => tabClick(1)}>Positions <span id="pos-count">({getPositionCount(positionMarge)})</span></Tab>
              <Tab onClick={() => tabClick(0)}>Orders  <span id="orders-count">({ordersList?.length || 0}) </span></Tab>
              <Tab onClick={() => tabClick(2)}>Trades  </Tab>
              <Tab onClick={() => tabClick(3)}>Logs  </Tab>
              <Tab onClick={() => tabClick(4)}>Funds  </Tab>
              <Tab disabled={true}>
                <div className="pnl-div-top ">
                  <p style={{ display: 'inline-flex', alignItems: 'center' }}>
                    Total PNL :
                    <span className={totalPNL.totalPNL === 0 ? "" : totalPNL.totalPNL > 0 ? "text-success" : "text-danger"}>
                      <b id={'top-total-pnl'}>{totalPNL?.totalPNL ? fmtINR(totalPNL?.totalPNL) : 0.00}</b>
                    </span>
                    <Tooltip
                      placement="top"
                      title="PNL Graph"
                      overlayStyle={{ position: 'fixed' }}
                    >
                      <span
                        role="button"
                        tabIndex={0}
                        onClick={() => { setLevel("broker"); setShowPnlModal(true); }}
                        onKeyDown={(e) => { if (e.key === 'Enter') { setLevel("broker"); setShowPnlModal(true); } }}
                        style={{ marginLeft: 8, display: 'inline-flex' }}
                      >
                        <BarChart3 className="pnl-graph ms-2" />
                      </span>
                    </Tooltip>
                  </p>
                </div>
              </Tab>
              <Tab disabled={true}>
                <Button
                  type="default"
                  size="small"
                  className={`d-flex align-items-center gap-1`}
                  onClick={() => refresh()}
                  style={{ height: '28px' }}
                >
                  <RefreshCw size={14} />
                  Sync Broker
                </Button>
              </Tab>
            </TabList>

            <>

              <TabPanel>
                {tabs == 1 &&
                  <>
                    <PositionsAction
                      exitOrders={exitOrders}
                      columns={columns}
                      totalPNL={totalPNL}
                      info={info}
                      type="1"
                      sltp={brokerSLTPRef.current}
                      isClosedPosition={isClosedPosition}
                      setisClosedPosition={setisClosedPosition}
                      setColumns={(item) => {
                        setColumns(item);
                        const minimized = item.map(group => ({
                          strategyHeader: group.strategyHeader?.map(c => ({ accessorKey: c.accessorKey, enableColumn: c.enableColumn })),
                          positionHeader: group.positionHeader?.map(c => ({ accessorKey: c.accessorKey, enableColumn: c.enableColumn }))
                        }));
                        setLocalStorageObject("columnSettings", "settings", minimized, localStorageObj);
                      }}
                      exitCE={exitCE}
                      exitPE={exitPE}
                      exitALL={exitALL}
                      searchText={searchText}
                      setSearchText={setSearchText}
                      checkedId={checkedId}
                      exitSelectedPositions={exitSelectedPositions}
                    ></PositionsAction>
                    <ListPositions
                      isClosedPosition={isClosedPosition}
                      position={position}
                      positionRef={positionMarge}
                      updateBasket={updateBasket}
                      setupdateBasket={setupdateBasket}
                      loder={positionLoder}
                      isDragBasket={isDragBasket}
                      setisDragBasket={(e) => setisDragBasket(e)}
                      sockSource={sockSource}
                      isFirstTime={isFirstTime}
                      loadPage={loadPage}
                      tabs={tabs}
                      buySellClick={buySellClick}
                      inputValues={inputValues}
                      getPNL={getPNL}
                      totalPNL={totalPNL}
                      socketPosition={socketPosition}
                      socketupdated={socketupdated}
                      info={info} height={height} width={width} size={size} columns={columns}
                      searchText={searchText}
                      checkedId={checkedId}
                      setcheckedId={setCheckedId}
                      groupingMode={groupingMode}
                      setGroupingMode={setGroupingMode}
                      subGroupingMode={subGroupingMode}
                      setSubGroupingMode={setSubGroupingMode}
                      basketMargins={basketMargins}
                    />
                  </>}
              </TabPanel>
              <TabPanel>
                <Suspense fallback={<LoderCom />}>
                  <ListOrdersCom sockSource={sockSource} socketOrders={socketOrders} info={info} height={height} width={width} size={size} inputValues={inputValues} />
                </Suspense>
              </TabPanel>
              <TabPanel>
                <Suspense fallback={<LoderCom />}>
                  <Trades info={info} height={height} width={width} size={size} socketTrade={socketTrade} />
                </Suspense>
              </TabPanel>

              <TabPanel>
                <Suspense fallback={<LoderCom />}>
                  <Logs socketOrdersLogs={socketOrdersLogs} info={info} height={height} width={width} size={size} />
                </Suspense>
              </TabPanel>
              <TabPanel>
                <Suspense fallback={<LoderCom />}>
                  <Funds info={info} height={height} width={width} size={size} />
                </Suspense>
              </TabPanel>
              <TabPanel></TabPanel>
              <TabPanel></TabPanel>


            </>
          </Tabs>
          <ScreenAction type="rightBottomWindow" screenClick={screenClick} />
        </div>
      </Card.Body>
      {showPnlModal && (
        <PnlMtmModal
          show={showPnlModal}
          onHide={() => setShowPnlModal(false)}
          title="PNL / MTM Graph"
          defaultLevel={level}
          brokerId={info?.broker?.id}
          brokerName={info?.selectedBroker}
          baskets={(positionMarge || []).filter((g) => g?.basketId && g.basketId !== "undefined").map((g) => ({ id: g.basketId, name: g?.data?.[0]?.basketName || g.basketId }))}
          positions={(positionMarge || []).flatMap((g) => (g?.data || [])).map((p) => ({ id: p.id, name: p.instrument?.displayName || p.tradingSymbol || p.id }))}
        />
      )}
      {showSyncModal && (
        <SyncBrokerModal
          show={showSyncModal}
          onHide={() => setShowSyncModal(false)}
          brokerId={info?.broker?.id}
          onSyncSuccess={startSyncProgress}
          syncStatus={brokerSyncStatus}
        />
      )}
      <ReconciliationNotification
        data={reconciliationData}
        show={showReconciliation}
        onClose={() => {
          setShowReconciliation(false);
          setReconciliationData(null);
        }}
      />

    </div>
  );
};

export default Position;
